import React, { useState, useEffect } from "react";
import {
  Grid,
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  ListItemText,
  Checkbox,
  Card,
  IconButton,
} from "@mui/material";
import Header from "../../../components/Header/Header";
import LeftSideBar from "../../../components/LeftSideBar/LeftSideBar";
import CloseIcon from "@mui/icons-material/Close";
import AdministratorHeader from "../../../components/Header/AdministratorHeader";
import { useNavigate } from "react-router-dom";
import "./dpCalculation.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  getDataCalculation,
  calculateDataPoints,
  clearApiStatus,
} from "../../../redux/administrator/actions";
import ProgressBar from "../../../components/ProgressBar";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import { useLocation } from "react-router-dom";
import { adminRoutes } from "../../../routes/routeConstants";

const Index = () => {
  const [fileName, setFileName] = useState([]);
  const [fileName1, setFileName1] = useState([]);
  const [fileName2, setFileName2] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const dataPoints = useSelector((state) => state?.admin?.dataPointCalculation);
  const apiStatus = useSelector((state) => state?.admin?.apiStatus);
  const [err, setErr] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const location = useLocation();
  const id = location?.state?.id;

  useEffect(() => {
    if (apiStatus && apiStatus !== undefined) {
      if (apiStatus.loader === false) {
        if (apiStatus?.next === true && apiStatus?.loader === false) {
          setSuccess(true);
          setMessage(apiStatus?.message);
          setTimeout(() => {
            navigate(`/${adminRoutes.dataPointDetails}`)
          }, 2000);
          dispatch(clearApiStatus());
        } else if (
          apiStatus?.message !== null &&
          apiStatus?.message !== undefined &&
          apiStatus?.next === false
        ) {
          setMessage(apiStatus?.message);
          setErr(true);
          dispatch(clearApiStatus());
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiStatus]);

  useEffect(() => {
    dispatch(clearApiStatus());
    dispatch(getDataCalculation(id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const removeCaptureEffort = (names) => {
    const temp = [...fileName];
    // removing the element using splice
    temp.splice(names, 1);
    // updating the list
    setFileName(temp);
  };
  const removeCaptureEffort1 = (names) => {
    const temp = [...fileName1];
    // removing the element using splice
    temp.splice(names, 1);
    // updating the list
    setFileName1(temp);
  };
  const removeCaptureEffort2 = (names) => {
    const temp = [...fileName2];
    // removing the element using splice
    temp.splice(names, 1);
    // updating the list
    setFileName2(temp);
  };

  const calculateDP = () => {
    let data = {
      id: id,
      fileName: fileName,
      fileName1: fileName1,
      fileName2: fileName2,
    };
    dispatch(calculateDataPoints(data));
  };

  return (
    <>
      <Header page="new-project" />
      <Box>
        <Grid className="sidebar-main" container>
          <Grid item className="sidebar-container">
            <LeftSideBar page="sidebar" />
          </Grid>
          <Grid item className="visualization-conatiner">
            <AdministratorHeader
              text="Manage Output Files"
              outPutButton={"Calculate"}
              Click={calculateDP}
            />
            <Grid container>
              <Grid item className="DpCalculation" md={4}>
                <Typography variant="subtitle2">Capture effort</Typography>
                <FormControl>
                  <InputLabel id="demo-simple-select-helper-label"></InputLabel>
                  <Select
                    size="small"
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    multiple
                    value={fileName}
                    onChange={(e) => {
                      setFileName(e.target.value);
                    }}
                    renderValue={(selected) => selected.join(", ")}
                  >
                    {dataPoints?.map((name) => (
                      <MenuItem key={name} value={name}>
                        <Checkbox checked={fileName.indexOf(name) > -1} />
                        <ListItemText primary={name} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <Box className="DpCalculation-list">
                  {fileName.map((names) => (
                    <Card className="DpCalculation-list-card" key={names}>
                      <Typography
                        className="DpCalculation-names"
                        variant="subtitle2"
                      >
                        {names}
                      </Typography>
                      <IconButton onClick={() => removeCaptureEffort(names)}>
                        <CloseIcon />
                      </IconButton>
                    </Card>
                  ))}
                </Box>
              </Grid>
              <Grid item className="DpCalculation" md={4}>
                <Typography variant="subtitle2">
                  Capture + Copy effort
                </Typography>
                <FormControl>
                  <InputLabel id="demo-simple-select-helper-label"></InputLabel>
                  <Select
                    size="small"
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    multiple
                    value={fileName1}
                    onChange={(e) => {
                      setFileName1(e.target.value);
                    }}
                    renderValue={(selected) => selected.join(", ")}
                  >
                    {dataPoints?.map((name) => (
                      <MenuItem key={name} value={name}>
                        <Checkbox checked={fileName1.indexOf(name) > -1} />
                        <ListItemText primary={name} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <Box className="DpCalculation-list">
                  {fileName1.map((names) => (
                    <Card className="DpCalculation-list-card" key={names}>
                      <Typography
                        className="DpCalculation-names"
                        variant="subtitle2"
                      >
                        {names}
                      </Typography>
                      <IconButton onClick={() => removeCaptureEffort1(names)}>
                        <CloseIcon />
                      </IconButton>
                    </Card>
                  ))}
                </Box>
              </Grid>
              <Grid item className="DpCalculation" md={4}>
                <Typography variant="subtitle2">
                  No. of underscores used
                </Typography>
                <FormControl>
                  <InputLabel id="demo-simple-select-helper-label"></InputLabel>
                  <Select
                    size="small"
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    multiple
                    value={fileName2}
                    onChange={(e) => {
                      setFileName2(e.target.value);
                    }}
                    renderValue={(selected) => selected.join(", ")}
                  >
                    {dataPoints?.map((name) => (
                      <MenuItem key={name} value={name}>
                        <Checkbox checked={fileName2.indexOf(name) > -1} />
                        <ListItemText primary={name} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <Box className="DpCalculation-list">
                  {fileName2.map((names) => (
                    <Card className="DpCalculation-list-card" key={names}>
                      <Typography
                        className="DpCalculation-names"
                        variant="subtitle2"
                      >
                        {names}
                      </Typography>
                      <IconButton onClick={() => removeCaptureEffort2(names)}>
                        <CloseIcon />
                      </IconButton>
                    </Card>
                  ))}
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {success && (
          <CustomizedSnackbars
            severity="success"
            state={success}
            text={message}
            handleClose={() => setSuccess(false)}
          />
        )}

        {err && (
          <CustomizedSnackbars
            severity="error"
            state={err}
            text={message}
            handleClose={() => setErr(false)}
          />
        )}

        {apiStatus?.loader === true && <ProgressBar></ProgressBar>}
      </Box>
    </>
  );
};

export default Index;
